import { IMotivoNotificacao } from "@/interfaces/IMotivoNotificacao";
import { api } from "@/services/api";
import { motivoNotificacaoAction } from "@/store/actions/motivoNotificacao";
import { getMotivosNotificacaoSynced } from "@/store/reducers/motivoNotificacao";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useMotivoNotificacao = () => {
  const { user } = useAuth();
  const appDispatch = useDispatch();
  const { sync } = motivoNotificacaoAction;
  const listaMotivosNotificacao = useSelector(getMotivosNotificacaoSynced);
  const motivosNotificacaoOptions = listaMotivosNotificacao.map((motivo) => ({
    label: motivo.nome.toUpperCase(),
    value: motivo.id,
  }));

  const sincronizarMotivosNotificacao = (items: IMotivoNotificacao[]) => {
    appDispatch(sync(items));
  };

  const getMotivosNotificacaoApi = async () => {
    const { data } = await api.get<IMotivoNotificacao[]>(
      "/motivos-notificacao/todos",
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  return {
    sincronizarMotivosNotificacao,
    listaMotivosNotificacao,
    getMotivosNotificacaoApi,
    motivosNotificacaoOptions,
  };
};
